_ = require 'underscore'
$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
AutocompleteMemberAvatar = require 'views/organization/invite-member-autocomplete-avatar'
Promise = require 'bluebird'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
templates = require 'views/internal/templates'

emailRegex = /([a-zA-Z0-9.+_-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
usernameRegex = /^@[a-z0-9_]{3,}$/

module.exports = class InviteTeamMembersAutoComplete extends React.Component
  constructor: (props) ->
    super
    @updateSearchResultList = _.debounce(@updateSearchResultList, 250)
    @searchForMembersPromise = null
    @selectMemberOption = @selectMemberOption.bind(@)
    @removeMemberOption = @removeMemberOption.bind(@)
    @onInputChange = @onInputChange.bind(@)
    @onInputFocus = @onInputFocus.bind(@)
    @onInputBlur = @onInputBlur.bind(@)
    @onInputKeyUp = @onInputKeyUp.bind(@)
    @onInputPaste = @onInputPaste.bind(@)
    @onAutocompleteKeyDown = @onAutocompleteKeyDown.bind(@)
    @onAutocompleteSubmit = @onAutocompleteSubmit.bind(@)
    @searchCache = {}
    @state =
      activeIndex: -1
      isOpen: false
      isFetching: false
      processingMembers: false
      isActive: true
      isTyping: false
      searchResults: []
      searchText: ''
      selectedOptions: []

  _sanitizeEmail = (email) ->
    return $.trim(email).toLowerCase().match(emailRegex)

  _sanitizeUsername = (username) ->
    return $.trim(username).toLowerCase().replace(/@/g, '')

  componentDidMount: ->
    @refs.searchInput.focus()

  componentDidUpdate: ->
    @refs.searchInput.focus()

  componentWillUnmount: ->
    @searchForMembersPromise?.cancel()

  updateSearchResultList: (searchVal) ->
    if !searchVal
      return

    searchResultList = @searchCache[searchVal]
    if searchResultList
      @receiveSearchResults(searchResultList)
    else
      @searchForMembers searchVal

  searchForMembers: (query, cb) ->
    @searchForMembersPromise?.cancel()
    @searchForMembersPromise = Promise.try =>
      if query.length > 2
        @setState({ isFetching: true })
        if usernameRegex.test(query)
          query = _sanitizeUsername(query)
        else if emailRegex.test(query)
          query = _sanitizeEmail(query)
        ApiPromise
          url: '/1/search/members/'
          type: 'get'
          data:
            query: query
            idOrganization: @props.orgId
          dataType: 'json'
    .cancellable()
    .then (resultList) =>
      @searchCache[query] = resultList
      @receiveSearchResults(resultList)
    .catch Promise.CancellationError, (=> @setState({ isFetching: false }))

  receiveSearchResults: (searchResults) ->
    searchResults = _.filter(searchResults, (result) =>
      result.active and (result.email || result.username)
    )
    @setState({
      isOpen: @state.isTyping and searchResults.length
      isFetching: false
      searchResults
    })

  selectMemberOption: (e, member) ->
    e.preventDefault()
    @searchForMembersPromise?.cancel()

    mergedOptions = _.uniq(
      _.union(@state.selectedOptions, _.flatten [member]),
      false,
      (item) => if item.username then item.username else item.email
    )

    @setState({
      selectedOptions: mergedOptions
      searchText: ''
      isOpen: false
    })
    @refs.searchInput.focus()

  removeMemberOption: (idx) ->
    @setState({
      selectedOptions: @state.selectedOptions.filter((_, i) => i != idx)
    })

  onInputBlur: (e) ->
    if emailRegex.test(e.target.value)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(e.target.value), (email) => { email }
      ))
    @setState({
      isOpen: false
      isActive: false
    })

  onInputChange: (e) ->
    e.persist()
    searchText = e.target.value
    @setState({
      searchText,
      isOpen: searchText != ''
    })
    @updateSearchResultList(searchText)

  onInputFocus: (e) ->
    @setState({ isActive: true })

  onInputKeyUp: (e) ->
    { searchText, selectedOptions } = @state

    if e.key in ['Enter', ',', ' '] and emailRegex.test(e.target.value) # enter, comma, or spacebar
      e.preventDefault()
      @setState({
        isOpen: false
        isTyping: false
      })
      # stop any running search queries
      @searchForMembersPromise?.cancel()
      # map out emails in the case of bulk copy + paste
      @selectMemberOption(e, _.map(
        _sanitizeEmail(e.target.value), (email) => { email }
      ))
    else if e.key is 'Backspace' and !e.target.value and selectedOptions.length
      @removeMemberOption(selectedOptions.length - 1)
    else
      @setState({ isTyping: true })

  onInputPaste: (e) ->
    clipboardValue = e.clipboardData.getData('Text')
    if emailRegex.test(clipboardValue)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(clipboardValue), (email) => { email }
      ))

  onAutocompleteKeyDown: (e) ->
    { activeIndex, searchResults } = @state
    switch e.key
      when 'Enter'
        if searchResults[activeIndex] and !searchResults[activeIndex].joined
          @setState({ activeIndex: -1 })
          @selectMemberOption(e, searchResults[activeIndex])
      when 'ArrowRight', 'ArrowDown'
        nextIndex = if activeIndex == searchResults.length - 1 then -1  else activeIndex + 1
        @setState({ activeIndex: nextIndex })
      when 'ArrowLeft', 'ArrowUp'
        prevIndex = if activeIndex == -1 then searchResults.length - 1 else activeIndex - 1
        @setState({ activeIndex: prevIndex })
      else null

  onAutocompleteSubmit: (e) ->
    { searchText } = @state
    { orgId } = @props
    if emailRegex.test(searchText)
      @selectMemberOption(e, _.map(
        _sanitizeEmail(searchText), (email) => { email }
      ))

    users = _.map(@state.selectedOptions, (option) =>
      if option.email then option.email else option.username
    )

    Promise.map(users, (user) =>
      @setState({ processingMembers: true })
      ApiPromise
        method: 'get'
        url: "/1/members/#{ user }"
        data: { fields: 'idOrganizations' }
      .catch ApiError.NotFound, (err) ->
        null
      .then (member) =>
        if member?
          if orgId in member.idOrganizations
            throw new ApiError.Conflict("already in organization")

          ApiPromise
            method: 'put'
            url: "/1/organizations/#{ orgId }/members/#{ member.id }"
            data:
              type: 'normal'
        else if emailRegex.test(user)
          ApiPromise
            method: 'post'
            url: "/1/organizations/#{ orgId }/memberships"
            data:
              email: user
              type: 'normal'
        else
          throw new ApiError.NotFound("username not found")
    , { concurrency: 5 })
    .done()

  render: t.renderable ->
    {
      activeIndex,
      isActive,
      isFetching,
      isOpen,
      processingMembers,
      searchResults,
      searchText,
      selectedOptions
    } = @state
    { placeholder, orgId } = @props

    validEmail = searchText.match(emailRegex)
    atLeastOnePill = selectedOptions.length > 0
    buttonIsEnabled = ((!atLeastOnePill and validEmail) or atLeastOnePill) and !processingMembers

    t.div '.org-team-members-autocomplete-container', =>
      t.div '.org-team-members-autocomplete', {
        class: t.classify({
          active: isActive or selectedOptions.length
          processing: processingMembers
        })
        onKeyDown: @onAutocompleteKeyDown
      }, =>
        t.div '.autocomplete-selected', =>
          if selectedOptions.length
            selectedOptions.map((member, idx) =>
              t.div '.autocomplete-option', =>
                t.createElement AutocompleteMemberAvatar,
                  _.extend {
                    onRemoveClick: (e) => @removeMemberOption(idx)
                  }, member
            )

          t.input '.autocomplete-input',
            type: 'text'
            onBlur: @onInputBlur
            onChange: @onInputChange
            onKeyUp: @onInputKeyUp
            onFocus: @onInputFocus
            onPaste: @onInputPaste
            disabled: processingMembers
            placeholder: if selectedOptions.length then '' else placeholder
            value: searchText
            ref: 'searchInput'

        if isOpen
          if isFetching
            t.div '.autocomplete-search-results', =>
              t.div '.spinner.loading'
          else
            if searchResults.length > 0
              t.div '.autocomplete-search-results', =>
                searchResults.map((member, idx) =>
                  memberAlreadySelected = _.find(selectedOptions, ({ id }) ->
                    id == member.id
                  )
                  disabled = memberAlreadySelected or member.joined or member.isDeactivated
                  activeMember = activeIndex == idx and !disabled
                  return t.div '.autocomplete-option', {
                    class: t.classify({
                      disabled
                      active: activeMember
                    })
                  }, =>
                    t.createElement AutocompleteMemberAvatar,
                      _.extend {
                        onMouseDown: (e) => @selectMemberOption(e, member)
                        displayDetails: true
                      }, member
                  )

      t.button '.autocomplete-btn.primary', {
        class: t.classify({ disabled: !buttonIsEnabled })
        disabled: !buttonIsEnabled
        onClick: @onAutocompleteSubmit
      }, ->
        if processingMembers
          t.div '.spinner.loading'
        else
          t.format 'invite-to-team'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-team-members-autocomplete-component.coffee